import { render } from "./TripList.vue?vue&type=template&id=051efc7f&scoped=true"
import script from "./TripList.vue?vue&type=script&lang=ts"
export * from "./TripList.vue?vue&type=script&lang=ts"

import "./TripList.vue?vue&type=style&index=0&id=051efc7f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-051efc7f"

export default script